import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, Table, Space, Card, Typography, DatePicker, message } from 'antd';
import dayjs from 'dayjs';
import { getData, sendData, sendDataBody } from '../../../../resources';
import HojaRegistroMiniModal from './hoja-registro-emt-box-mini-modal';
import EmtBoxDeleteRecord from './emt-box-delete-record';
import EmtBoxDeleteCell from './emt-box-delete-cell';

const { Title } = Typography;
const { Option } = Select;

const HojaRegistroEmtBox = ({ idVisita, idPaciente }) => {

  const [form] = Form.useForm();


  const [boxes, setBoxes] = useState([])

  useEffect(() => {
    getBoxes();
  }, [idVisita])

  const getBoxes = async () => {
    const res = await getData(`emt-box/visita/${idVisita}/${idPaciente}`);
    console.log('All boxes: ', res)
    setBoxes(res);
  }


  // Estado para las fechas seleccionadas
  const [fechas, setFechas] = useState([
    dayjs(),
    dayjs().add(1, 'day'),
    dayjs().add(2, 'day'),
    dayjs().add(3, 'day'),
    dayjs().add(4, 'day'),
    dayjs().add(5, 'day'),
  ]);

  // Datos iniciales de la tabla
  const initialData = [
    {
      key: '1',
      protocolo: '',
      zonas: '',
      pulsos: '',
      fechas: {}
    },
  ];

  const [tableData, setTableData] = useState(() => {
    // Inicializar datos con las fechas predeterminadas
    return initialData.map(row => ({
      ...row,
      fechas: fechas.reduce((acc, fecha) => {
        const fechaStr = fecha.format('DD/MM/YY');
        acc[fechaStr] = {
          pulsos: '',
          nivel: ''
        };
        return acc;
      }, {})
    }));
  });

  const handleCellChange = (recordKey, fecha, field, value) => {
    const newData = tableData.map(record => {
      if (record.key === recordKey) {
        return {
          ...record,
          fechas: {
            ...record.fechas,
            [fecha]: {
              ...record.fechas[fecha],
              [field]: value
            }
          }
        };
      }
      return record;
    });
    setTableData(newData);
  };

  const handleBasicFieldChange = (recordKey, field, value) => {
    const newData = tableData.map(record => {
      if (record.key === recordKey) {
        return {
          ...record,
          [field]: value
        };
      }
      return record;
    });
    setTableData(newData);
  };

  const handleDateChange = (index, newDate) => {
    if (!newDate) return;

    const newFechas = [...fechas];
    newFechas[index] = newDate;
    setFechas(newFechas);

    // Actualizar las claves de fechas en tableData
    const oldFechaStr = fechas[index].format('DD/MM/YY');
    const newFechaStr = newDate.format('DD/MM/YY');

    const newData = tableData.map(record => {
      const newFechasData = { ...record.fechas };

      // Copiar datos de la fecha antigua a la nueva (si existe)
      if (newFechasData[oldFechaStr]) {
        newFechasData[newFechaStr] = { ...newFechasData[oldFechaStr] };
        delete newFechasData[oldFechaStr];
      } else {
        newFechasData[newFechaStr] = {
          pulsos: '',
          nivel: ''
        };
      }

      return {
        ...record,
        fechas: newFechasData
      };
    });

    setTableData(newData);
  };

  const agregarFecha = () => {
    const nuevaFecha = dayjs();
    setFechas([...fechas, nuevaFecha]);

    // Agregar la nueva fecha a todos los registros
    const newData = tableData.map(record => ({
      ...record,
      fechas: {
        ...record.fechas,
        [nuevaFecha.format('DD/MM/YY')]: {
          pulsos: '',
          nivel: ''
        }
      }
    }));

    setTableData(newData);
  };

  const agregarFila = () => {
    const newRow = {
      key: `${tableData.length + 1}`,
      protocolo: '',
      zonas: '',
      pulsos: '',
      fechas: fechas.reduce((acc, fecha) => {
        const fechaStr = fecha.format('DD/MM/YY');
        acc[fechaStr] = { pulsos: '', nivel: '' };
        return acc;
      }, {})
    };
    setTableData([...tableData, newRow]);
  };

  const eliminarFila = (key) => {
    if (tableData.length <= 1) {
      alert('Debe haber al menos una fila');
      return;
    }
    setTableData(tableData.filter(record => record.key !== key));
  };

  const eliminarFecha = (index) => {
    if (fechas.length <= 1) {
      alert('Debe haber al menos una fecha');
      return;
    }

    const fechaAEliminar = fechas[index].format('DD/MM/YY');
    const newFechas = fechas.filter((_, i) => i !== index);
    setFechas(newFechas);

    // Eliminar la fecha de todos los registros
    const newData = tableData.map(record => {
      const newFechasData = { ...record.fechas };
      delete newFechasData[fechaAEliminar];
      return {
        ...record,
        fechas: newFechasData
      };
    });

    setTableData(newData);
  };

  const columns = [
    {
      title: 'Protocolo',
      dataIndex: 'protocolo',
      key: 'protocolo',
      width: 120,
      fixed: 'left',
      render: (text, record) => (
        <Input
          size="small"
          value={text}
          onChange={(e) => handleBasicFieldChange(record.key, 'protocolo', e.target.value)}
          placeholder="Protocolo"
        />
      )
    },
    {
      title: 'Zonas',
      dataIndex: 'zonas',
      key: 'zonas',
      width: 100,
      fixed: 'left',
      render: (text, record) => (
        <Input
          size="small"
          value={text}
          onChange={(e) => handleBasicFieldChange(record.key, 'zonas', e.target.value)}
          placeholder="Zonas"
        />
      )
    },
    {
      title: 'Pulsos',
      dataIndex: 'pulsos',
      key: 'pulsos',
      width: 120,
      fixed: 'left',
      render: (text, record) => (
        <Input
          size="small"
          value={text}
          onChange={(e) => handleBasicFieldChange(record.key, 'pulsos', e.target.value)}
          placeholder="Pulsos"
        />
      )
    },
    {
      title: 'Acciones',
      key: 'acciones',
      width: 100,
      fixed: 'left',
      render: (_, record) => (
        <Button
          size="small"
          danger
          onClick={() => eliminarFila(record.key)}
        >
          Eliminar
        </Button>
      )
    },
    ...fechas.map((fecha, index) => {
      const fechaStr = fecha.format('DD/MM/YY');
      return {
        title: (
          <div>
            <DatePicker
              value={fecha}
              onChange={(date) => handleDateChange(index, date)}
              format="DD/MM/YY"
              size="small"
              style={{ marginBottom: 4, width: '100%' }}
            />
            <Button
              size="small"
              danger
              onClick={() => eliminarFecha(index)}
              style={{ width: '100%' }}
            >
              Eliminar
            </Button>
          </div>
        ),
        key: fechaStr,
        width: 150,
        render: (_, record) => (
          <div>
            <Input
              size="small"
              value={record.fechas[fechaStr]?.pulsos || ''}
              onChange={(e) => handleCellChange(record.key, fechaStr, 'pulsos', e.target.value)}
              style={{ marginBottom: 4 }}
              placeholder="Pulsos"
            />
            <Select
              size="small"
              value={record.fechas[fechaStr]?.nivel || undefined}
              onChange={(value) => handleCellChange(record.key, fechaStr, 'nivel', value)}
              style={{ width: '100%' }}
              placeholder="Nivel"
              allowClear
            >
              <Option value="Nivel 1">Nivel 1</Option>
              <Option value="Nivel 2">Nivel 2</Option>
              <Option value="Nivel 3">Nivel 3</Option>
              <Option value="Nivel 4">Nivel 4</Option>
              <Option value="Nivel 5">Nivel 5</Option>
            </Select>
          </div>
        ),
      };
    }),
  ];

  const handleSubmit = () => {
    console.log('data to send', tableData)


    form.validateFields().then(values => {
      const data = {
        id_paciente: idPaciente,
        id_visita: idVisita,
        protocolos: tableData
      }
      sendDataBody('emt-box/add', data).then(res => {
        if (res.message === "EMT Box creado correctamente") {
          message.success(res.message)
          getBoxes();
        } else {
          message.error(res.error)
        }
        console.log(res)
      }).catch(err => {
        console.error('Error de validación:', err);
      })
    }).catch(err => {
      console.error('Error de validación:', err);
    });
  };

  return (
    <div >

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {
          boxes.map((box) => (

            // Example of box: {
            //     "_id": "6978ce377f4d87dad4e35ca3",
            //     "id_paciente": "690c12c60078302b35516f9f",
            //     "id_visita": "6940a93ac4651c555fceecc3",
            //     "protocolos": [
            //         {
            //             "key": "1",
            //             "protocolo": "CTBS",
            //             "zonas": "Z1",
            //             "pulsos": "24000",
            //             "fechas": {
            //                 "31/01/26": {
            //                     "pulsos": "1200",
            //                     "nivel": "Nivel 2"
            //                 },
            //                 "30/01/26": {
            //                     "pulsos": "1200",
            //                     "nivel": "Nivel 2"
            //                 }
            //             }
            //         },
            //         {
            //             "key": "2",
            //             "protocolo": "iTBS",
            //             "zonas": "z2",
            //             "pulsos": "1200",
            //             "fechas": {
            //                 "31/01/26": {
            //                     "pulsos": "1200",
            //                     "nivel": "Nivel 2"
            //                 },
            //                 "30/01/26": {
            //                     "pulsos": "2411",
            //                     "nivel": "Nivel 4"
            //                 }
            //             }
            //         }
            //     ],
            //     "createdAt": "2026-01-27T14:39:51.931Z",
            //     "updatedAt": "2026-01-27T14:39:51.931Z",
            //     "__v": 0
            // } 
            <div key={box._id}>
              {/* {JSON.stringify(box)} */}
              {
                box.protocolos.map((protocolo) => (
                  <div key={protocolo.key} style={{ border: '1px solid #d9d9d9', padding: '10px', borderRadius: '10px', display: 'flex', flexDirection: 'row', gap: '10px', marginTop: '10px' }}>
                    <div style={{ width: 150 }}><strong>Protocolo:</strong> {protocolo.protocolo}</div>
                    <div style={{ width: 100 }}><strong>Zonas:</strong> {protocolo.zonas}</div>
                    <div style={{ width: 120 }}><strong>Pulsos Totales:</strong> {protocolo.pulsos}</div>
                    <div style={{ display: 'flex', gap: '15px', flex: 1, overflowX: 'auto' }}>
                      {Object.entries(protocolo.fechas).map(([fecha, info]) => (
                        <div key={fecha} style={{ borderLeft: '1px solid #f0f0f0', paddingLeft: '10px', minWidth: '100px' }}>
                          <div style={{ fontSize: '11px', color: '#8c8c8c' }}>{fecha}</div>
                          <div style={{ fontSize: '13px' }}><strong>P:</strong> {info.pulsos}</div>
                          <div style={{ fontSize: '13px' }}><strong>N:</strong> {info.nivel}</div>
                          <EmtBoxDeleteCell record={protocolo} box={box} fecha={fecha} fetchBoxes={getBoxes} />
                        </div>
                      ))}
                      <HojaRegistroMiniModal protocolo={protocolo} boxId={box._id} fetchBoxes={getBoxes} />
                      {/* DELETE RECORD */}
                      <EmtBoxDeleteRecord record={protocolo} box={box} retrieveBoxes={getBoxes} />
                    </div>

                  </div>
                ))
              }
            </div>
          ))
        }
      </div>

      <br />

      <Space style={{ marginBottom: 16 }}>
        <Button type="primary" ghost onClick={agregarFila}>
          + Agregar Fila
        </Button>
        <Button type="dashed" onClick={agregarFecha}>
          + Agregar Fecha
        </Button>
      </Space>

      <div style={{ overflowX: 'auto', marginBottom: 24 }}>
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={false}
          bordered
          size="small"
          scroll={{ x: 1200 }}
        />
      </div>

      <Space>
        <Button type="primary" onClick={handleSubmit}>
          Guardar Datos
        </Button>
        {/* <Button onClick={() => {
          console.log('Datos actuales:', tableData);
          alert('Revisa la consola para ver los datos actuales');
        }}>
          Ver Datos Actuales
        </Button> */}
      </Space>



    </div>
  );
};

export default HojaRegistroEmtBox;